import { SVGProps } from 'react';

const AddIcon = ({
  height = '10.248px',
  width = '10.248px',
  strokeWidth = '2',
  className,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    className={className ? className : 'stroke-current transform rotate-45'}
    viewBox='0 0 10.248 10.248'
    {...props}
  >
    <g id='add_icon' transform='translate(1.414 1.414)'>
      <line
        id='Line_14'
        data-name='Line 14'
        x1='7.42'
        y1='7.42'
        fill='none'
        strokeLinecap='round'
        strokeLinejoin='bevel'
        strokeWidth={strokeWidth}
      />
      <line
        id='Line_15'
        data-name='Line 15'
        x1='7.42'
        y2='7.42'
        fill='none'
        strokeLinecap='round'
        strokeLinejoin='bevel'
        strokeWidth={strokeWidth}
      />
    </g>
  </svg>
);

export default AddIcon;
